import {
    setSubscriptionToDetails,
    setSubscriptionToQuote,
    updateStagnantInstrumentsToBackend,
    updateTickerSubscriptionWithKite,
} from "../../../../services/apiService";
import { setGridItemHeight } from "@dashboard/grid-components/announcements/AnnouncementUtil";

// For details we no longer use a fixed expanded H here.
// Height is measured by MoreDetailsLayout via setGridItemHeight.

export const handleShowDetails = (
    stocks,
    instrumentEntity,
    setLayouts,
    tabID,
    itemIndex,
    rowVirtualizer
) => {
    const clickedStock = stocks[itemIndex];
    if (!clickedStock) return;

    const isOpening = !clickedStock.isDetailsVisible;

    if (isOpening) {
        // 👉 OPEN DETAILS
        clickedStock.isDetailsVisible = true;
        setSubscriptionToDetails(instrumentEntity.instrumentToken, "tabID:" + tabID);

        setLayouts(prevLayouts =>
            prevLayouts.map((item, index) =>
                index === itemIndex
                    ? { ...item, h: 10 }
                    : item
            )
        );

    } else {
        // 👉 CLOSE DETAILS
        clickedStock.isDetailsVisible = false;
        setSubscriptionToQuote(instrumentEntity.instrumentToken, "tabID:" + tabID);

        // When closing, collapse row back to 1 height-unit (same as announcements close)
        setGridItemHeight(1, setLayouts, itemIndex);
    }

    // Ask the virtualizer to re-measure this row after DOM updates are flushed
/*    if (rowVirtualizer) {
        requestAnimationFrame(() => {
            const selector = `[data-row-key="${tabID}-${instrumentEntity.instrumentToken}"]`;
            const el = document.querySelector(selector);

            if (el && typeof rowVirtualizer.measureElement === "function") {
                rowVirtualizer.measureElement(el);
            }
        });
    }*/
};

// Utility function to generate random sentences
export const generateRandomSentence = () => {
    const sentences = [
        "This is a random sentence.",
        "Another small random sentence.",
        "Here's some random text.",
        "Randomness at its best.",
        "Simple and short.",
        "Generated text for demo.",
        "Smooth and simple writing.",
        "Text to fill the space.",
        "Another random line here.",
        "Last but not least.",
    ];
    return sentences[Math.floor(Math.random() * sentences.length)];
};
